import { createFileRoute } from '@tanstack/react-router'

import { RedeemEntryPoint } from '@/features/redeem/redeem.lazy'
import { CircleLoadingAnimation } from '@vgw/multibrand-fe-circle-loading-animation'
import { TakeABreakHeader } from '@/features/account-locked/take-a-break-header'
import { AccountLockedLinks } from '@/features/account-locked/account-locked-links'
import { useGetTakeABreakStateQuery } from '@/features/take-a-break/use-get-take-a-break-state-query'

export const Route = createFileRoute('/_app/account-locked/take-a-break')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isPending, data } = useGetTakeABreakStateQuery()

  if (isPending) {
    return <CircleLoadingAnimation className="mx-auto" />
  }

  return (
    <>
      {data?.defined ? <TakeABreakHeader validTo={data?.validTo} /> : null}
      <AccountLockedLinks redemption accountVerification accessControls />

      <RedeemEntryPoint />
    </>
  )
}
